export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    headerAlign: 'center',
    field: 'transferRuleName',
    align: 'left',
    width: 280,
    title: '中转策略名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'custName',
    align: 'left',
    width: 200,
    title: '客户',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'originProvinceName',
    align: 'left',
    width: 100,
    title: '始发省份',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'originCityName',
    align: 'left',
    width: 100,
    title: '始发城市',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'originDistrictName',
    align: 'left',
    width: 100,
    title: '始发区县',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'originPlace',
    align: 'left',
    width: 200,
    title: '始发地',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'destinationProvinceName',
    align: 'left',
    width: 100,
    title: '目的省份',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'destinationCityName',
    align: 'left',
    width: 100,
    title: '目的城市',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'destinationDistrictName',
    align: 'left',
    width: 100,
    title: '目的区县',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'destination',
    align: 'left',
    width: 200,
    title: '目的地',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'transferRuleRemarks',
    align: 'left',
    width: 250,
    title: '备注信息',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'transferRuleStatus',
    align: 'center',
    width: 80,
    title: '状态',
    slots: { default: 'status' },
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: '创建时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
]
